let total_accounts = 0
let temp = 100
let check = true
let total_multi_text_records = 0

$(document).ready(function () {
  influence_visual_feedback_and_mandatory_correct_for_interactive_page({
    fieldNeutral: "#multi_choice_page_neutral",
    fieldVisualFeedback: "#multi_choice_page_visual_feedback",
    fieldMandatoryCorrect: "#multi_choice_page_mandatory_correct",
  })

  if (document.getElementById("multi_choice_page_multi_choice") == undefined) {
    return
  }

  if (!$("#multi_choice_page_multi_choice").is(":checked")) {
    $(".multi-choice-answers").find('input[type="checkbox"]').on("click", check_box_click_listener)
    check = false
  }

  if (document.getElementById("new_multi_choice_page") == undefined) {
    total_multi_text_records = $(".multi-choice-answers").children().length / 2
  } else {
    total_multi_text_records = 1
  }

  document.getElementById("multi_choice_page_multi_choice").addEventListener("click", function () {
    check = this.checked
    if (check) {
      $(".multi-choice-answers").find('input[type="checkbox"]').off("click", check_box_click_listener)
      $("#multi_choice_page_multi_choice").val(true)
    } else {
      $(".multi-choice-answers").find('input[type="checkbox"]').on("click", check_box_click_listener)
      check_box_click_listener()
      $("#multi_choice_page_multi_choice").val(false)
    }
  })
})

window.remove_multi_text_fields = function (link) {
  $(link).siblings().val(1)
  $(link).parent().parent().parent().remove()
  total_multi_text_records--
}

window.add_multi_text_fields = function (link, association, fields_to_clone, view) {
  if (total_multi_text_records >= 10) {
    alert("Can't add more than 10 answers")
    return
  }
  total_multi_text_records++
  if (view == "new") {
    total_accounts++
  } else {
    temp++
    total_accounts = temp
  }
  let regexp = new RegExp("new_" + association, "g")
  $(".multi-choice-answers").append(fields_to_clone.replace(regexp, total_accounts))
  if (!check) {
    if ($("#multi_choice_page_multi_choice")[0].checked) {
      $(".multi-choice-answers").find('input[type="checkbox"]').off("click", check_box_click_listener)
    } else {
      $(".multi-choice-answers").find('input[type="checkbox"]').on("click", check_box_click_listener)
    }
  }
}

function check_box_click_listener() {
  let checkboxes = $(".multi-choice-answers").find('input[type="checkbox"]')
  for (let i = 0; checkboxes[i]; i++) {
    if (this != checkboxes[i]) {
      checkboxes[i].checked = false
    }
  }
}

$("#multi_choice_page_mandatory_correct").on("click", function () {
  if ($("#multi_choice_page_mandatory_correct").is(":checked")) {
    if (!$("#multi_choice_page_feedback").is(":checked")) {
      $("#multi_choice_page_feedback").click()
    }
    if ($("#multi_choice_page_neutral").is(":checked")) {
      $("#multi_choice_page_neutral").click()
    }
  }
})

$("#multi_choice_page_neutral").on("click", function () {
  influence_visual_feedback_and_mandatory_correct_for_interactive_page({
    fieldNeutral: "#multi_choice_page_neutral",
    fieldVisualFeedback: "#multi_choice_page_visual_feedback",
    fieldMandatoryCorrect: "#multi_choice_page_mandatory_correct",
  })
})

$("#multi_choice_page_feedback").on("click", function () {
  if (!$("#multi_choice_page_feedback").is(":checked")) {
    if ($("#multi_choice_page_mandatory_correct").is(":checked")) {
      $("#multi_choice_page_mandatory_correct").click()
    }
  }
})
